<template>
  <div class="entry-info entry-info-person">
    <!-- 新建报名展示赛事信息与收费；已有报名（查看/编辑）不展示 -->
    <div class="title-info" v-if="project.unionMatchId && !teamId">
      <div class="title-info-logo">
        <img :src="imageView(project.icon)" alt="">
      </div>
      <div class="title-info-right">
        <div class="row row-name">{{ project.chineseName || project.unionMatchName || '-' }}</div>
        <div class="row row-group">组别：{{ project.matchGroupName || '-' }}</div>
        <div class="row" v-if="project.genderLimit !== 3">
          允许性别：{{ project.genderLimit === 1 ? '男' : project.genderLimit === 2 ? '女' : '混合' }}
        </div>
        <div class="row" v-if="project.isOpenAgeLimit === 1">
          参赛年龄：{{ getFormatDate(project.maxAge) }}
          {{ project.maxAge && project.minAge ? ' ~ ' : '' }}
          {{ getFormatDate(project.minAge) }}
        </div>
        <div class="row row-fee" v-if="project.feeMethod !== 0">
          收费方式：{{ getFeeMethodsLabel(project.feeMethod) }} 金额：{{ project.feeAmount != null ? (project.feeAmount / 100).toFixed(2) : '0.00' }}元/人
        </div>
      </div>
    </div>
    <!-- 报名须知：与 entry-info-team 一致，黄条 + 弹框 -->
    <div
      v-if="!teamId && (project.signupInstructionsOpen === 1 || project.signupInstructionsOpen === 2) && signupInstructions"
      class="signup-notice-bar"
      @click="openSignupInstructionsPopup"
    >
      <van-icon name="volume-o" class="notice-icon" />
      <span class="notice-text" :title="signupInstructionsText">{{ signupInstructionsText || '报名须知' }}</span>
      <span class="notice-link">查看详情 &gt;</span>
    </div>
    <div class="entry-person-main">
    <!-- 与 entry-info-team-detail：查看态显示「编辑」，编辑态显示底部操作 -->
    <div class="person-detail-header">
      <span class="person-detail-title">报名资料</span>
      <van-button
        v-if="teamId && canEditPersonal && !isEditing"
        class="person-detail-edit-btn"
        size="small"
        type="primary"
        plain
        @click="goEdit"
      >
        编辑
      </van-button>
    </div>
    <div class="tabs" v-if="tabs.length > 1">
      <van-tabs v-model="active" @change="changeTab">
        <van-tab v-for="tab in tabs" :key="tab.value" :title="tab.text"></van-tab>
      </van-tabs>
    </div>
    <div v-show="active === 0">
      <PlayerForm 
        ref="playerForm"
        hide-personal-title
        :form-readonly="formReadonly"
        :form.sync="player"
        :player-signup-fields="psfs"
        :jerseys-size-fields="project.jerseysSizeFields"
        :jerseys-size-accessory="project.jerseysSizeAccessory"
        :player-number-range="project.playerNumberRange"
        :cert-type-columns="certTypeColumns"
        :player-signup-fields-label="playerSignupFieldsLabel"
        :sport-type="project.sportType"
        :max-age="project.maxAge"
        :min-age="project.minAge"
        :qiniu-token="qiniuToken"
        :gender-limit="project.genderLimit"
        :custom-text-options="project.customTextOptions"
      />
    </div>
    <div
      v-show="activeValue === 'backgroundForm'"
      class="sub-form-wrap"
      :class="{ 'sub-form-readonly': formReadonly }"
    >
      <BackgroundForm ref="backgroundForm" :qiniu-token="qiniuToken" @update:form="updateBackgroundForm" :form="background" />
    </div>
    <div
      v-show="activeValue === 'equipmentForm'"
      class="sub-form-wrap"
      :class="{ 'sub-form-readonly': formReadonly }"
    >
      <EquipmentForm ref="equipmentForm" @update:form="updateEquipmentForm" :form="equipmentInfo" />
    </div>
    <div
      v-show="activeValue === 'mediaForm'"
      class="sub-form-wrap"
      :class="{ 'sub-form-readonly': formReadonly }"
    >
      <MediaForm ref="mediaForm" @update:form="updateSocialMediaUsing" :form="socialMediaUsing" />
    </div>
    </div>
    <div v-if="!teamId && project.signupExplanation" class="bottom-explanation">
      <div class="bottom-explanation-title">说明</div>
      <div class="bottom-explanation-content" v-html="signupExplanationHtml"></div>
    </div>
    <!-- <div style="height: 120px;"></div> -->
    <div v-if="showButton && showBottomBar && tabs.length === 1">
      <div class="bottom" v-if="!teamId">
        <div @click="showAgreementFun" v-if="project.isUseAgreement === 1 && agreementList.length > 0"
          style="display: flex; justify-content: center; padding: 0 0 8px 0">
          <van-checkbox disabled v-model="allow" shape="square" icon-size="16px">
            <span style="font-size: 13px; color: #8C8C8C">报名前请先同意</span>
            <span v-for="item in agreementList" :key="item.id" style="color: #409EFF; font-size: 13px;">《{{ item.title
            }}》</span>
          </van-checkbox>
        </div>
        <van-button
          type="info"
          block
          @click="savePlayer"
          :style="{'background-color':jetlympic? '#00A7FF': 'var(--bg3)' }"
          style="border: none; color: #FFFFFF; height: 50px; border-radius: 25px"
        >{{ $t(`match.registration.button_text`) }}</van-button>
      </div>
      <div class="bottom-actions" v-else>
        <van-button
          class="bottom-btn"
          type="info"
          @click="updatePlayer"
          :style="{ 'background-color': jetlympic ? '#00A7FF' : '#509DEA' }"
        >保存</van-button>
      </div>
    </div>
    <div v-else-if="showButton && showBottomBar">
      <div class="footer">
        <div class="prev" @click="prev" :class="{ disabled: active === 0 }">上一页</div>
        <div class="next" @click="next" v-if="active < tabs.length - 1">下一页</div>
        <div class="submit" @click="submit" v-else>提交</div>
      </div>
    </div>
    <div class="popup">
      <van-popup v-model="showBirthday" position="bottom" :style="{ height: '50%' }">
        <van-datetime-picker v-model="currentDate" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate"
          @cancel="cancelBirthdayTime" @confirm="confirmBirthdayTime" />
      </van-popup>
      <van-popup v-model="showCertType" position="bottom" :style="{ height: '50%' }">
        <van-picker title="请选择证件类型" show-toolbar :columns="certTypeColumns" @confirm="onConfirmCertType"
          @cancel="onCancelCertType" />
      </van-popup>
      <van-popup v-model="showArea" round position="bottom">
        <van-cascader v-model="player.domicileAreaId" :title="`请选择${playerSignupFieldsLabel.domicileAreaId || '所在地区'}`" :options="options" :field-names="fieldNames"
          @close="showArea = false" @change="onChange" @finish="onFinish" />
      </van-popup>
      <van-popup v-model="showAgreement" position="bottom" round :style="{ height: '70%' }">
        <div id="agreement"></div>
        <div style="height: 115px;"></div>
        <div class="bottom">
          <van-button type="info" block @click="allowAgreement"
            :style="{'background-color':jetlympic? '#00A7FF': '#191919' }" style="border: none; color: #FFFFFF; height: 50px; border-radius: 25px">同意条款</van-button>
        </div>
      </van-popup>
    </div>
    <van-dialog v-model="showDialog" title="提交成功" @confirm="goEntryList" confirm-button-text="我的参赛" theme="round-button"
      confirm-button-color="darkblue">
      <div style="font-size: 13px; color: #333333; padding: 12px 20px 10px 20px">
        <span style="display: inline-block; font-size: 13px; width: 2em;"></span>
        报名提交成功，您可以前往我的参赛列表查看报名进度
      </div>
    </van-dialog>
    <van-popup v-model="signupInstructionsOpen" :close-on-click-overlay="false"
      :style="{ width: '80%', 'border-radius': '4px' }">
      <div class="notice">
        <div class="notice-title">报名须知</div>
        <div class="info" v-html="signupInstructions"></div>
        <div class="close" :class="{ 'disabled': time > 0 }" @click="closeNotice">
          我知道了 <span v-if="time > 0">({{ time }})</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { DateUtil, QNImageUtil, RegExpr, ToolUtil } from "@/utils";
import { debounce } from "@/utils/debounce";
import Vue from 'vue'
import {
  Form, Field, Icon, Popup, Loading, Overlay, Dialog, Uploader, Cascader,
  RadioGroup, Radio, DatetimePicker, Button, Picker, Checkbox, Toast,
  Tabs, Tab
} from 'vant'
import { getQiniuUploadToken, uploadImage } from "@/api/qiniu";
import {
  createBMMatchSingle,
  getAreaTreeList,
  getBMMatchTeamSignup,
  updateBMMatchSingle
} from "@/api/match";
import { getPassport } from "@/libs/passport";
import { feeMethodOptions, playerSignupFieldsLabel } from "@/config";
import Cookies from 'js-cookie'

Vue.use(Form).use(Field).use(Icon).use(Popup).use(Checkbox)
  .use(Loading).use(Overlay).use(Dialog).use(Uploader).use(RadioGroup)
  .use(Radio).use(Button).use(DatetimePicker).use(Picker).use(Cascader)
  .use(Tabs).use(Tab)

const certTypeOption = [
  { value: 1, label: '身份证' },
  { value: 2, label: '护照' },
  { value: 3, label: '港澳通行证' },
  { value: 4, label: '台胞证' },
  { value: 5, label: '港澳台回乡证' }
]
const certTypeColumns = ['身份证', '护照', '港澳通行证', '台胞证', '港澳台回乡证']
import PlayerForm from '@/components/PlayerForm'
import BackgroundForm from '@/components/BackgroundForm'
import EquipmentForm from '@/components/EquipmentForm'
import MediaForm from '@/components/MediaForm'
export default {
  components: {
    PlayerForm,
    BackgroundForm,
    EquipmentForm,
    MediaForm
  },
  data() {
    return {
      teamId: '',
      allow: false,
      showDialog: false,
      team: {},
      certTypeColumns: [
        { value: 1, label: '身份证' },
        { value: 11, label: '学籍卡' },
        { value: 2, label: '护照' },
        { value: 3, label: '港澳通行证' },
        { value: 4, label: '台胞证' },
        { value: 5, label: '港澳台回乡证' }
      ],
      showBirthday: false,
      showCertType: false,
      qiniuToken: '',
      player: {
        certType: 1,
        certTypeValue: '身份证'
      },
      project: {},
      minDate: '',
      maxDate: '',
      currentDate: '',
      defaultCertIndex: 0,
      options: [],
      fieldNames: {
        text: 'name',
        value: 'id',
        children: 'kids',
      },
      showArea: false,
      playerCheckboxes: {},
      agreementList: [],
      showAgreement: false,
      title: '',
      projectId: '',
      showButton: false,
      signupInstructionsOpen: false,
      time: 5,
      signupInstructions: '',
      playerSignupFieldsLabel:playerSignupFieldsLabel,
      psfs: [],
      active: 0,
      activeValue: 'playerForm',
      tabs: [{ text: '个人信息', value: 'playerForm' }],
      background: {},
      equipmentInfo: {},
      socialMediaUsing: {},
      jetlympic: false,
      unionMatchId: '',
      /** 是否处于编辑态（新建默认 true；已有报名进入后为查看态，点「编辑」为 true） */
      isEditing: true
    }
  },
  computed: {
    /** 与 entry-info-team-detail：未提交或已退回时可编辑 */
    canEditPersonal() {
      const t = this.team
      if (!this.teamId || !t || Object.keys(t).length === 0) return false
      return t.isSubmit === 0 || t.auditStatus === -1
    },
    /** 个人信息表单只读：已有报名且当前为查看态 */
    formReadonly() {
      return !!(this.teamId && !this.isEditing)
    },
    /** 底部保存/提交条：新建始终显示；已有报名仅编辑态显示（同 team-detail） */
    showBottomBar() {
      if (!this.teamId) return true
      return this.isEditing
    },
    /** 底部说明 HTML：与 entry-info-team 一致 */
    signupExplanationHtml() {
      const text = (this.project && this.project.signupExplanation) || ''
      return text ? text.replace(/\n/g, '<br/>') : ''
    },
    /** 报名须知纯文本（黄条一行展示） */
    signupInstructionsText() {
      if (!this.signupInstructions) return ''
      if (typeof document === 'undefined') return ''
      const div = document.createElement('div')
      div.innerHTML = this.signupInstructions
      return (div.textContent || div.innerText || '').trim()
    }
  },
  watch: {
    'player.IDCardNo': {
      handler() {
        if (RegExpr.isIdCard(this.player.IDCardNo)) {
          const player = JSON.parse(JSON.stringify(this.player))
          player.gender = '' + ToolUtil.getSex(player.IDCardNo)
          player.bmBirthdayValue = ToolUtil.getBirthday(player.IDCardNo)
          player.bmBirthday = DateUtil.parseDateTime(ToolUtil.getBirthday(this.player.IDCardNo), '{y}-{m}-{d}T00:00:00+0800')
          this.player = player
        }
      }
    },
    'player.gender': {
      handler() {
        if (this.playerCheckboxes.gender && (this.project.genderLimit != 0 && this.project.genderLimit != 3) && this.player.gender != this.project.genderLimit) {
          Toast({ type: 'fail', message: '性别异常' })
        }
      }
    },
    active: {
      handler(newVal) {
        this.changeTab(newVal)
      }
    }
  },
  mounted() {
    if (window.localStorage.getItem('jetlympic')) {
      this.jetlympic = true
    }
    // 创建防抖版本的 savePlayer 方法
    this.savePlayer = debounce(this._savePlayer, 500)
    
    getPassport().then(res => {
      if (res) {
        this.unionMatchId = this.$route.query.unionMatchId
        this.projectId = this.$route.query.matchId
        this.teamId = this.$route.query.teamId
        this.getQiniuUploadToken()
        this.getAreaTreeList()
      }
    })
  },
  methods: {
    /** 与 entry-info-team-detail.goEdit */
    goEdit() {
      if (!this.canEditPersonal) return
      this.isEditing = true
      this.getQiniuUploadToken()
    },
    openSignupInstructionsPopup() {
      this.signupInstructionsOpen = true
    },
    changeTab(value) {
      this.activeValue = this.tabs[value].value
    },
    prev() {
      if(this.active === 0) return
      this.active--
    },
    next(){
      this.active++
    },
    submit() {   
      this.$refs.playerForm.validate().then(() => { // 个人信息校验
        this.$refs[this.tabs[1].value].validateForm().then(() => { // 第二个tab足球背景校验
          if(this.tabs.length > 2){
            this.$refs[this.tabs[2].value].validateForm().then(() => { // 第三个tab装备信息校验
              if(this.tabs.length > 3){
                this.$refs[this.tabs[3].value].validateForm().then(() => { // 第四个tab社交媒体使用校验
                  this.submitForm()
                }).catch(() => {
                  this.$toast(`请完善${this.tabs[3].text}`)
                  this.active = 3
                })
              }else{
                this.submitForm()
              }
            }).catch(() => {
              this.$toast(`请完善${this.tabs[2].text}`)
              this.active = 2
            })
          }else{
            this.submitForm()
          }
        }).catch((e) => {
          console.log(e);
          this.$toast(`请完善${this.tabs[1].text}`)
          this.active = 1
        })
      }).catch(() => {
        this.$toast('请完善个人信息')
        this.active = 0
      })
    },
    submitForm() {
      if (this.playerCheckboxes.gender && (this.project.genderLimit != 0 && this.project.genderLimit != 3) && this.player.gender != this.project.genderLimit) {
        Toast({ type: 'fail', message: '性别异常' })
        this.active = 0
        return
      }
      let params = {}
      const player = JSON.parse(JSON.stringify(this.player))
      params.matchId = this.projectId
      delete player.avatarList
      delete player.IDCardPhotoAList
      delete player.IDCardPhotoBList
      delete player.qualificationFileList
      delete player.insureFileList
      delete player.showPlayerInfo
      delete player.domicileAreaName
      delete player.bmBirthdayValue
      delete player.certTypeValue
      params = {
        ...params,
        ...player,
        background: JSON.stringify(this.background),
        equipmentInfo: JSON.stringify(this.equipmentInfo),
        socialMediaUsing: JSON.stringify(this.socialMediaUsing)
      }
      if(this.teamId){
        params.teamId = this.teamId
        this.updatePlayerForm(params)
        return
      }
      createBMMatchSingle(params).then(res => {
        if (res) {
          this.teamId = res.data.id
          this.replaceToSignupSheet()
        }
      })
    },
    updatePlayerForm(form) {
      updateBMMatchSingle(form).then(res => {
        if (res) {
          Toast.success('保存成功')
          this.isEditing = false
          this.getBMMatchTeamSignup()
        }
      })
    },
    updateBackgroundForm(form) {
      console.log(form);
      this.background = form
    },
    updateEquipmentForm(form) {
      console.log(form);
      this.equipmentInfo = form
    },
    updateSocialMediaUsing(form) {
      console.log(form);
      this.socialMediaUsing = form
    },
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getLabel(type) {
      const label = this.playerSignupFieldsLabel[type]
      return label
    },
    closeNotice() {
      if (this.time <= 0) {
        this.signupInstructionsOpen = false
        Cookies.set(this.projectId, this.projectId)
      }
    },
    getFeeMethodsLabel(value) {
      const item = feeMethodOptions.find(f => f.value === value)
      if (!item) return '--'
      return item.label
    },
    checkIDCardNoDis(value) {
      return RegExpr.isIdCard(value)
    },
    showBirthdayFun() {
      if (RegExpr.isIdCard(this.player.IDCardNo)) return
      this.showBirthday = true
    },
    allowAgreement() {
      this.allow = true
      this.showAgreement = false
    },
    showAgreementFun() {
      this.showAgreement = true
      setTimeout(() => {
        const agreement = document.getElementById('agreement')
        let inner = ''
        this.agreementList.forEach(a => {
          inner += `<div style="background-color: #fff; padding: 12px 12px 0 12px;text-align: center;font-weight: 600;font-size: 24px;margin-bottom: 4px;">${a.title}</div>`
          inner += a.content
        })
        agreement.innerHTML = inner
      }, 0)
    },
    onChange({ selectedOptions }) {
      const a = []
      selectedOptions.forEach(item => {
        a.push(item.name)
      })
      this.player.domicileAreaName = a.join('/')
      console.log(this.player.domicileAreaName, this.player.domicileAreaId)
    },
    onFinish({ selectedOptions }) {
      const a = []
      selectedOptions.forEach(item => {
        a.push(item.name)
      })
      this.player.domicileAreaName = a.join('/')
      this.showArea = false
    },
    getAreaTreeList() {
      getAreaTreeList().then(res => {
        if (res) {
          const { data } = res
          this.options = JSON.parse(data.list.list.replaceAll("'", '"')) || []
          this.getBMMatchTeamSignup()
        }
      })
    },
    getAreaInfo(areaId, options, a) {
      if (!areaId) return ''
      for (let i = 0; i < options.length; i++) {
        if (options[i].id === areaId) {
          a.push(options[i].name)
          return true
        } else if (options[i].kids) {
          const b = this.getAreaInfo(areaId, options[i].kids, a)
          if (b) {
            a.push(options[i].name)
            return true
          }
        }
      }
      return false
    },
    checkMobile(value) {
      return RegExpr.checkMobile(value)
    },
    /** 创建成功后进入对应报名单（与 entry-list2 / payment-success 一致：0 队伍 1 个人 2 组合） */
    replaceToSignupSheet() {
      const q = {
        unionMatchId: this.unionMatchId,
        matchId: this.projectId,
        teamId: this.teamId
      }
      const u = Number(this.project && this.project.unitType)
      if (u === 2) {
        this.$router.replace({ path: '/entry-page/entry-info-more', query: q })
      } else if (u === 0) {
        this.$router.replace({ path: '/entry-page/entry-info', query: q })
      } else {
        this.$router.replace({ path: '/entry-page/person-info', query: q })
      }
    },
    goEntryList() {
      this.$router.replace('/entry-page/entry-list?unionMatchId=' + this.unionMatchId)
      // this.$router.push({ path: '/entry-page/team-operate', query: { unionMatchId: this.unionMatchId,matchId:this.projectId } })
    },
    getBMMatchTeamSignup() {
      const params = {
        matchId: this.projectId
      }
      if (this.teamId) {
        params.teamId = this.teamId
      }
      this.tabs = [{ text: '个人信息', value: 'playerForm' }]
      this.active = 0
      this.activeValue = 'playerForm'
      getBMMatchTeamSignup(params).then(res => {
        if (res) {
          const data = res.data || {}

          if (data.team) {
            this.showButton = (data.team.auditStatus != 2 && (data.team.isSubmit === 0 || data.team.auditStatus === -1))
          } else {
            this.showButton = true
          }
          this.isEditing = !this.teamId
          if (data.match.playerSignupFieldsLabel) {
            this.playerSignupFieldsLabel = {
              ...this.playerSignupFieldsLabel,
              ...data.match.playerSignupFieldsLabel,
            }
          }

          const project = data.match
          this.certTypeColumns = this.certTypeColumns.filter(item => project.certTypeFields.indexOf(item.value) > -1) // 动态证件类型
          this.agreementList = data.agreement || []
          const psfs = project.playerSignupFields && project.playerSignupFields.split('|') || []
          this.psfs = psfs 
          if (psfs.includes('background')) {
            this.tabs.push({text: '足球背景', value: 'backgroundForm'})
          }
          if (psfs.includes('equipmentInfo')) {
            this.tabs.push({text: '装备信息', value: 'equipmentForm'})
          }
          if (psfs.includes('socialMediaUsing')) {
            this.tabs.push({text: '社交媒体使用', value: 'mediaForm'})
          }
          this.minDate = project.maxAge ? new Date(project.maxAge) : new Date(1970, 0, 1)
          this.maxDate = project.minAge ? new Date(project.minAge) : new Date()
          const playerCheckboxes = {}
          psfs.forEach(psf => {
            playerCheckboxes[psf] = true
          })
          this.playerCheckboxes = playerCheckboxes
          this.project = data.match
          this.team = data.team || {}
          const players = data.players || []
          if (players.length > 0) {
            const player = players[0]
            player.bmBirthdayValue = player.bmBirthday && this.getFormatDate(player.bmBirthday) || ''
            player.certTypeValue = player.certType && certTypeColumns[player.certType - 1] || '身份证'
            if (player.certTypeValue === '身份证') {
              player.certType = 1
            }
            player.avatarList = player.avatar && [{ url: QNImageUtil.imageView(player.avatar), isImage: true }] || []
            player.IDCardPhotoAList = player.IDCardPhotoA && [{ url: QNImageUtil.imageView(player.IDCardPhotoA), isImage: true, hash: player.IDCardPhotoA }] || []
            player.IDCardPhotoBList = player.IDCardPhotoB && [{ url: QNImageUtil.imageView(player.IDCardPhotoB), isImage: true, hash: player.IDCardPhotoB }] || []
            if (player.qualificationFile && player.qualificationFile.length > 0) {
              const a = player.qualificationFile.split(',') || []
              player.qualificationFileList = []
              a.forEach(item => {
                player.qualificationFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item })
              })
            } else {
              player.qualificationFileList = []
            }
            if (player.insureFile && player.insureFile.length > 0) {
              const a = player.insureFile.split(',') || []
              player.insureFileList = []
              a.forEach(item => {
                player.insureFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item })
              })
            } else {
              player.insureFileList = []
            }
            const a = []
            this.getAreaInfo(player.domicileAreaId, this.options, a)
            a.reverse()
            player.domicileAreaName = a.join('/')
            this.background = player.background || {}
            this.equipmentInfo = player.equipmentInfo || {}
            this.socialMediaUsing = player.socialMediaUsing || {}
            console.log(this.socialMediaUsing,'this.socialMediaUsing');
            this.player = player
          }
          // signupInstructionsOpen: 0=未开启 1=必须阅读 2=非必须（与 entry-info-team 一致）
          if (project.signupInstructionsOpen === 1 || project.signupInstructionsOpen === 2) {
            this.signupInstructions = project.signupInstructions
          }
          if (project.signupInstructionsOpen === 1 && Cookies.get(this.projectId) != this.projectId) {
            this.signupInstructionsOpen = true
            const timer = setInterval(() => {
              this.time--
              if (this.time === 0) {
                clearInterval(timer)
              }
            }, 1000)
          }
        }
      })
    },
    getQiniuUploadToken() {
      getQiniuUploadToken({}).then(res => {
        this.qiniuToken = res.data.token
      })
    },
    checkIDCardNo(value) {
      if (this.player.certType === 1) return RegExpr.isIdCard(value)
      return true
    },
    showCertTypeFun() {
      this.showCertType = true
    },
    onConfirmCertType(value) {
      this.player.certTypeValue = value
      const item = certTypeOption.find(i => i.label === value)
      this.player.certType = item.value
      this.showCertType = false
    },
    onCancelCertType() {
      const index = this.roleColumns.findIndex(item => item === this.player.certTypeValue)
      this.defaultCertIndex = index > -1 ? index : 0
      this.showCertType = false
    },
    uploadAvatar(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.player.avatar = res.hash
      })
    },
    deleteAvatar() {
      this.player.avatar = this.player.avatarList.join(',') ?? ''
    },
    uploadIDCardPhotoA(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.player.IDCardPhotoA = res.hash
      })
    },
    deleteIDCardPhotoA() {
      this.player.IDCardPhotoA = this.player.IDCardPhotoAList.join(',') ?? ''
    },
    uploadQualificationFile(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        const player = JSON.parse(JSON.stringify(this.player))
        if (player.qualificationFile && player.qualificationFile.length > 0) {
          player.qualificationFile = player.qualificationFile + ',' + res.hash
        } else {
          player.qualificationFile = res.hash
        }
        const a = player.qualificationFile.split(',')
        player.qualificationFileList = []
        a.forEach(item => {
          player.qualificationFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item },)
        })
        this.player = player
      })
    },
    deleteQualificationFile() {
      const player = JSON.parse(JSON.stringify(this.player))
      const a = []
      player.qualificationFileList.forEach(item => {
        a.push(item.hash)
      })
      player.qualificationFile = a.join(',')
      this.player = player
    },
    uploadInsureFile(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        const player = JSON.parse(JSON.stringify(this.player))
        if (player.insureFile && player.insureFile.length > 0) {
          player.insureFile = player.insureFile + ',' + res.hash
        } else {
          player.insureFile = res.hash
        }
        const a = player.insureFile.split(',') || []
        player.insureFileList = []
        a.forEach(item => {
          player.insureFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item },)
        })
        this.player = player
      })
    },
    deleteInsureFile() {
      const player = JSON.parse(JSON.stringify(this.player))
      const a = []
      player.insureFileList.forEach(item => {
        a.push(item.hash)
      })
      player.insureFile = a.join(',')
      this.player = player
    },
    uploadIDCardPhotoB(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.player.IDCardPhotoB = res.hash
      })
    },
    deleteIDCardPhotoB() {
      this.player.IDCardPhotoB = this.player.IDCardPhotoBList.join(',') ?? ''
    },
    updatePlayer() {
      if (this.playerCheckboxes.gender && (this.project.genderLimit != 0 && this.project.genderLimit != 3) && this.player.gender != this.project.genderLimit) {
        Toast({ type: 'fail', message: '性别异常' })
        return
      }
      this.$refs.playerForm.validate().then(() => {
        const params = JSON.parse(JSON.stringify(this.player))
        params.teamId = this.teamId
        params.matchId = this.projectId
        delete params.avatarList
        delete params.IDCardPhotoAList
        delete params.IDCardPhotoBList
        delete params.qualificationFileList
        delete params.insureFileList
        delete params.showPlayerInfo
        delete params.domicileAreaName
        delete params.bmBirthdayValue
        delete params.certTypeValue
        updateBMMatchSingle(params).then(res => {
          if (res) {
            Toast.success('保存成功')
            this.isEditing = false
            this.getBMMatchTeamSignup()
          }
        })
      })
    },
    _savePlayer() {
      if (this.playerCheckboxes.gender && (this.project.genderLimit != 0 && this.project.genderLimit != 3) && this.player.gender != this.project.genderLimit) {
        Toast({ type: 'fail', message: '性别异常' })
        return
      }
      if (this.project.isUseAgreement === 1 && this.agreementList.length > 0 && !this.allow) {
        Toast.fail('请先同意协议或条款')
        return
      }
      this.$refs.playerForm.validate().then(() => {
        const params = JSON.parse(JSON.stringify(this.player))
        params.matchId = this.projectId
        delete params.avatarList
        delete params.IDCardPhotoAList
        delete params.IDCardPhotoBList
        delete params.qualificationFileList
        delete params.insureFileList
        delete params.showPlayerInfo
        delete params.domicileAreaName
        delete params.bmBirthdayValue
        delete params.certTypeValue
        createBMMatchSingle(params).then(res => {
          if (res) {
            this.teamId = res.data.id
            this.replaceToSignupSheet()
          }
        })
      })
    },
    getFormatDate(date) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, '{y}-{m}-{d}')
    },
    confirmBirthdayTime(value) {
      this.player.bmBirthdayValue = DateUtil.parseDateTime(value, '{y}-{m}-{d}')
      this.player.bmBirthday = DateUtil.parseDateTime(value, '{y}-{m}-{d}T00:00:00+0800')
      this.showBirthday = false
    },
    cancelBirthdayTime() {
      this.showBirthday = false
    }
  }
}
</script>

<style lang="scss" scoped>
/* 与 entry-info-team 报名页一致的页面底色与留白 */
.entry-info.entry-info-person {
  min-height: 100vh;
  background-color: rgb(246, 246, 248);
  padding-bottom: 120px;
  box-sizing: border-box;
  .title-info {
    display: flex;
    align-items: flex-start;
    padding: 16px;
    background-color: #fff;
    .title-info-logo {
      width: 42px;
      height: 42px;
      border-radius: 50%;
      overflow: hidden;
      flex-shrink: 0;
      background: #e8e8e8;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .title-info-right {
      flex: 1;
      min-width: 0;
      margin-left: 12px;
    }
    .row {
      font-size: 13px;
      color: #606266;
      line-height: 20px;
      margin-top: 6px;
      &:first-child {
        margin-top: 0;
      }
    }
    .row-name {
      font-size: 15px;
      font-weight: 600;
      color: #1d2129;
      line-height: 22px;
    }
    .row-group {
      color: #606266;
    }
    .row-fee {
      color: #606266;
    }
  }

  .signup-notice-bar {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background: #ffc60a;
    color: #000;
    font-size: 12px;
    cursor: pointer;
    .notice-icon {
      flex-shrink: 0;
      margin-right: 8px;
      font-size: 16px;
    }
    .notice-text {
      flex: 1;
      min-width: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .notice-link {
      flex-shrink: 0;
      margin-left: 8px;
    }
  }

  .entry-person-main {
    margin: 0;
    background: #fff;
    overflow: hidden;
    padding-bottom: 8px;
  }

  /* 与 entry-info-team-detail .team-detail-header 一致 */
  .person-detail-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 12px;
    height: 50px;
    box-sizing: border-box;
    background: #fff;
    border-bottom: 1px solid #ebedf0;
    .person-detail-title {
      font-size: 15px;
      font-weight: 500;
      color: #1d2129;
    }
    .person-detail-edit-btn {
      width: 68px;
      height: 30px;
      padding: 0;
      font-size: 13px;
      color: var(--bg3);
      background-color: #e9e9eb;
      border: none;
    }
  }

  .sub-form-wrap.sub-form-readonly {
    pointer-events: none;
    user-select: none;
  }

  .bottom-explanation {
    padding: 12px 16px;
    background-color: #fff;
    border-top: 1px solid #ebedf0;
    .bottom-explanation-title {
      font-weight: bold;
      font-size: 15px;
      color: #1d2129;
      margin-bottom: 8px;
    }
    .bottom-explanation-content {
      font-size: 14px;
      color: #606266;
      line-height: 1.6;
      &::v-deep ul {
        margin: 0;
        padding-left: 20px;
      }
      &::v-deep li {
        margin-bottom: 4px;
      }
    }
  }

  .bottom {
    position: fixed;
    bottom: 0;
    width: 100vw;
    padding: 14px 12px 12px 12px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }

  /* 与 entry-info-team-detail 底部「保存」一致（已有报名编辑） */
  .bottom-actions {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 12px 16px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: flex-end;
    box-sizing: border-box;
    .bottom-btn {
      width: 132px;
      height: 50px;
      border: none;
      color: #ffffff;
      border-radius: 25px;
    }
  }

  .footer{
    position: fixed;
    bottom: 0;
    width: 100vw;
    background-color: #FFFFFF;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px 34px 12px;
    div{
      width: 157px;
      height: 45px;
      border-radius: 69px;
      font-size: 15px;
      font-weight: 500;
      border-width: 1px;
      border-style: solid;
      text-align: center;
      line-height: 45px;
      &.prev{
        border-color: #409EFF;
        color: #409EFF;
      }
      &.next,&.submit{
        border-color: #509DEA;
        color: #fff;
        background-color: #509DEA;
      }
      &.disabled{
        border-color: #C7C9CC;
        color: #C7C9CC;
      }
    }
  }
}

.agreement-top {
  .agreement-title {
    background-color: #fff;
    padding: 12px 12px 0 12px;
    text-align: center;
    font-weight: 600;
    font-size: 24px;
    margin-bottom: 4px;
  }

  .hint {
    text-align: center;
    font-size: 16px;
    color: #8C8C8C;
  }
}

.notice {
  .notice-title {
    text-align: center;
    font-size: 16px;
    padding: 12px 0;
    // border-bottom: 1px solid #f3f3f3;
  }

  .info {
    padding: 12px;
    max-height: 40vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    white-space: pre-wrap;
  }

  .close {
    text-align: center;
    color: #576B95;
    // border-top: 1px solid #f3f3f3;
    padding: 12px 0;
  }

  .disabled {
    color: #999 !important;
  }
}

#agreement {
  padding: 0 24px 12px 24px;

  .wscnph {
    width: 100%;
  }
}
::v-deep .van-tabs__line {
  background-color: #1989fa !important;
}
::v-deep .van-cell {
  min-height: 54px;
  box-sizing: border-box;
  align-items: center;
}
::v-deep .van-field__label {
  color: rgba(0, 0, 0, 0.9);
}
::v-deep .van-field__control {
  font-weight: 500;
}
/* 足球背景 / 装备 / 媒体 分区标题与球队页灰条一致 */
::v-deep .background-form .title,
::v-deep .equipment-form .title,
::v-deep .media-form .title {
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  font-weight: normal;
  color: #909399;
  background-color: #f6f6f6;
  padding-left: 15px;
}
</style>
